import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { herbalWalk } from '@/assets/siteMedia'
import { pillars } from '@/data/about'

export const AboutPhilosophy = () => (
  <section className="border-t border-base-200 bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader
            title="Four foundations of"
            accent="Instrumental Health"
            description="Kandake's practice is built on the conviction that real healing happens when traditional wisdom, rigorous science, community, and personal empowerment work together, not in isolation."
            className="mb-8"
          />
          <Reveal>
            <SitePhoto
              src={herbalWalk}
              alt="Kandake leading a community herbal walk"
              aspect="aspect-[16/9]"
            />
          </Reveal>
        </div>

        <ol className="space-y-4">
          {pillars.map((p, i) => (
            <li key={p.label}>
              <Reveal delay={i * 80}>
                <div className="flex gap-5 rounded-3xl border border-base-200 bg-white p-6 transition-colors hover:border-green-300">
                  <span className="shrink-0 pt-0.5 font-display text-sm text-gold-500">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="mb-1.5 font-display text-xl text-base-900">{p.label}</h3>
                    <p className="text-sm leading-6 text-base-600">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
)
